import React from 'react';
import LoadUser from 'src/components/common/LoadUser';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import SnackBar from 'src/components/common/SnackBar';
import { useModalState } from 'src/context/ModalContext';
import CumaModal from 'src/components/common/v2/modal/CumaModal';
import CumaModalContents from 'src/components/common/v2/modal/CumaModalContents';
import { useAppDispatch, useAppSelector } from 'src/hooks/hooks';
import { closeWarningModal } from 'src/store/modal/modalSlice';
import styled from 'styled-components';
import ProgressBar from 'src/components/common/v2/modal/ProgressBar';
import CumaAIButton from 'src/components/common/v2/CumaAIButton';
import { Helmet } from 'react-helmet-async';
import { configByPlatform } from 'src/config/platform';

const AppLayoutBlock = styled.div`
    padding: 90px 30px 40px 190px;
    background-color: #f5f5f5;
    /* width: fit-content; */
    width: 100%;
    /* height: 100%; */
    min-height: calc(var(--vh), 1vh) * 100;

    display: flex;
    flex-direction: column;
`;
interface Props {
    children: React.ReactNode;
}

function AppLayout({ children }: Props) {
    const isOpen = useAppSelector(state => state.modal.warningModal.isOpen);
    const text = useAppSelector(state => state.modal.warningModal.text);
    const progressModal = useAppSelector(state => state.modal.progressModal);
    const dispatch = useAppDispatch();
    const { isOpen: modalIsOpen, modalStyle, confirmButtonDisabled, setIsOpen } = useModalState();

    React.useEffect(() => {
        if (modalStyle) {
            setIsOpen(true);
        } else {
            setIsOpen(false);
        }
    }, [modalStyle]);

    React.useEffect(() => {
        const link: HTMLLinkElement = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = configByPlatform.favicon;
        document.getElementsByTagName('head')[0].appendChild(link);
    }, []);

    return (
        <AppLayoutBlock>
            <Helmet>
                <title>{configByPlatform.title}</title>
            </Helmet>
            <CumaAIButton />
            <LoadUser />
            {children}
            <SnackBar />
            <ProgressBar progress={0} />
            {isOpen && (
                <CumaModal>
                    <CumaModalContents
                        modalStyleType={{
                            type: 'warning',
                            contents: text,
                            onClickConfirmButton: () => dispatch(closeWarningModal()),
                        }}
                    />
                </CumaModal>
            )}
            {modalIsOpen && (
                <CumaModal>
                    <CumaModalContents modalStyleType={modalStyle} confirmButtonDisabled={confirmButtonDisabled} />
                </CumaModal>
            )}
            {progressModal && (
                <CumaModal>
                    <LoadingSpinner />
                </CumaModal>
            )}
        </AppLayoutBlock>
    );
}

export default AppLayout;
